import { select, call, all } from 'redux-saga/effects';
import { AppSelectors } from '../Redux/modules/app/selectors';

function* forkIfOrgAdmin(effect) {
  const isOrgAdmin = yield select(AppSelectors.isOrgAdminSelector);

  if (isOrgAdmin) {
    yield call(effect);
  }
}

function* allIfLogged(effects) {
  const isLogged = yield select(AppSelectors.isLoggedSelector);

  if (isLogged) {
    yield all(effects);
  }
}

function* allIfOrgAdmin(effects) {
  const isOrgAdmin = yield select(AppSelectors.isOrgAdminSelector);

  if (isOrgAdmin) {
    yield all(effects);
  }
}

export default {
  forkIfOrgAdmin,
  allIfOrgAdmin,
  allIfLogged,
};
